import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { SizeVariantsGrid } from './size-variants-grid';
import { getSizeTitle } from './utils';
import type { IVariantsProps } from '../types';

export const SizeVariantsMobileVersion: React.FC<IVariantsProps> = props => {
  const { variants, handleSelection, isMobile } = props;
  const { t } = useAppContext();

  return (
    <SizeVariantsGrid
      variants={variants}
      handleSelection={handleSelection}
      title={getSizeTitle(t)}
      isMobile={isMobile}
    />
  );
};
